import { render, staticRenderFns } from "./ProductInfoModal.vue?vue&type=template&id=08985fe3&scoped=true&"
import script from "./ProductInfoModal.vue?vue&type=script&lang=js&"
export * from "./ProductInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoModal.vue?vue&type=style&index=0&id=08985fe3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08985fe3",
  null
  
)

export default component.exports